<ng-container [formGroup]="form">
	<div gdColumns="repeat(auto-fill, minmax(250px, 1fr))" gdGap="10px">
		<mat-form-field>
			<input
				autocomplete="company-name"
				matInput
				required
				placeholder="Company Name"
				formControlName="name"
				maxlength="50"
			/>
			<mat-error>Required</mat-error>
		</mat-form-field>
		<mat-form-field>
			<input
				autocomplete="employer-identification-number"
				matInput
				placeholder="Tax Id"
				formControlName="employerIdentificationNumber"
				maxlength="10"
			/>
		</mat-form-field>
	</div>
	<rpshared-address formControlName="address"> </rpshared-address>
</ng-container>
